export default "__VITE_ASSET__0J1RF5K8__"